import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { Event } from '../../types/Types';

interface useGetEventRequestsProps {
  eventId: string;
  enabled?: boolean;
}

export function useGetEvent({ eventId, enabled = true }: useGetEventRequestsProps) {
  return useQuery({
    enabled,
    queryKey: ['event', eventId],
    queryFn: async () => {
      return axiosInstance<Event>(getAPIURL(`/Event/${eventId}/`)).then(
        (response) => response.data,
      );
    },
  });
}